/** globals BS */

/**
 * 日付を yyyy-mm-dd 形式で返す
 * @param {Date|BS.Date} date 日付
 * @return {string}
 */
export function printDate (date) {
	return [
		date.getFullYear(),
		('0' + (date.getMonth() + 1)).substr(-2),
		('0' + date.getDate()).substr(-2)
	].join('-')
}

/**
 * 曜日の名前（英語, 3文字, 小文字）を返す
 * @param {Date|BS.Date} date 日付
 * @return {string}
 */
export function dayName (date) {
	return ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][date.getDay()]
}

/**
 * 時刻の文字列表現を時間単位の整数値にする
 *  - '09:00' => 9
 *  - '09:30' => 9.5
 *  - '10:15:30 => 10.25833
 * @param {string} str
 * @return {number}
 */
export function timeStringToHours (str) {
	const parts = str.split(':').slice(0, 3)
	return parts.reverse().reduce((hours, part) => {
		return (hours / 60) + Math.min(parseInt(part, 10), 60)
	}, 0)
}
